import mapFileFromApi from './mapFileFromApi';

export const mapCommentItemFromApi = (resp: ApiComment): CommentListItem => {
  return {
    id: resp.id,
    text: resp.text,
    author: mapCommentAuthorFromApi(resp.author),
    createdAt: new Date(resp.create_timestamp * 1000),
    updatedAt: new Date(resp.update_timestamp * 1000),
    isEditable: resp.is_editable,
    isRemovable: resp.is_removable,
    isSelf: resp.is_self,
  };
};

export const mapCommentAuthorFromApi = (
  resp: ApiCommentAuthor
): Commentator => {
  return {
    fullName: resp.fullname,
    photo: mapFileFromApi(resp.photo),
  };
};
